export default __webpack_public_path__ + "4037c4d3bf5963503b0774d161476a4f.svg";